import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import useSpeclialisedList from "../../hooks/useSpeclialisedList";

const ChooseCatpopup = (props) => {
  const { speclialisedList } = useSpeclialisedList();
  const { handleSpeclialisedList, speclialisedIDs, ...modalConfig } = props;

  return (
    <div>
      {" "}
      <Modal
        {...modalConfig}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="cat-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5 className="head-cat">
              Choose the category as per your specialization
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap gap-2">
            {
              speclialisedList.length > 0 && (
                speclialisedList.map((item, idx) => {
                  return (
                    <span
                      onClick={() => handleSpeclialisedList(item)}
                      className={`tab-bedges cursor-pointer ${speclialisedIDs.includes(item?._id) && 'active'}`}
                      key={idx}
                    >
                      {item?.title}
                    </span>
                  )
                })
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-select mt-0" onClick={props.onHide}>
            Selected ({speclialisedIDs?.length})
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChooseCatpopup;
